import React, { useState } from "react";
import useForm from './hooks/useForm';
import { FormField, LoadingIcon } from '@prosolve/common-components-ui'
import useFetch from './hooks/useFetch';
import { useNavigate } from "react-router-dom";
import { getClientSubdomain } from './utils';
import {
  Page,
  MazeOverlay,
  Card,
  BrandLogo,
  Head,
  Title,
  Subtitle,
  FieldWrap,
  fieldLabelStyle,
  ErrorSlot,
  SubmitRow,
  SubmitButton,
  SpinnerWrap,
  Foot,
  Tagline
} from './sharedComponents/AuthPageLayout';

export default () => {
  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get('token');
  const id = urlParams.get('id');

  const navigate = useNavigate();

  const clientSubdomain = getClientSubdomain()

  const isStarSubdomain = (clientSubdomain === 'star')

  const fetch = useFetch();

  const [isBusy, setIsBusy] = useState(false);
  const [showInvalidLogin, setShowInvalidLogin] = useState('');

  const formSchema = {
    requiredFields: ['password', 'confirmPassword'],
    initData: {
      password: '',
    }
  }

  const formData = useForm(formSchema)

  const onClickSubmit = async () => {
    if (formData.isValid() && formData.values.password === formData.values.confirmPassword ) {
      setIsBusy(true)

      const postObj = {
        ...formData.values,
        token,
        id
      }

      const response = await fetch(
        `auth/resetPassword`,
        {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
          body: JSON.stringify(postObj)
        }
      )

      const jsonData = await response.json() || {};

      const { status = '' } = jsonData;

      if (status) {
        navigate('/')
      } else {
        setShowInvalidLogin('An error has occured')
      }

      setIsBusy(false)
    } else {
      if (formData.values.password !== formData.values.confirmPassword) {
        setShowInvalidLogin('Passwords do not match')
      }
    }
  }

  const onKeyDown = (e) => {
    if (e.key === 'Enter') {
      onClickSubmit();
    }
  }

  return (
    <Page $isStar={isStarSubdomain}>

      { !isStarSubdomain && <MazeOverlay aria-hidden="true" /> }

      <Card>

        { !isStarSubdomain && <BrandLogo /> }

        <Head>
          <Title>{'Reset Password'}</Title>
          <Subtitle>{'Create your new password below.'}</Subtitle>
        </Head>

        <FieldWrap $invalid={!!formData.missingValues['password']}>
          <FormField
            label='Password'
            labelStyle={fieldLabelStyle}
            fieldId='password'
            type='password'
            placeholder='Enter your new password'
            formData={formData}
            onKeyDown={onKeyDown}
          />
        </FieldWrap>

        <FieldWrap $invalid={!!formData.missingValues['confirmPassword']}>
          <FormField
            label='Confirm Password'
            labelStyle={fieldLabelStyle}
            fieldId='confirmPassword'
            type='password'
            placeholder='Re-enter your new password'
            formData={formData}
            onKeyDown={onKeyDown}
          />
        </FieldWrap>

        <ErrorSlot>
          { (!isBusy && Boolean(showInvalidLogin)) ? showInvalidLogin : '' }
        </ErrorSlot>

        <SubmitRow>
          <SubmitButton onClick={onClickSubmit}>
            {'Reset Password'}
          </SubmitButton>
          {
            isBusy &&
            <SpinnerWrap>
              <LoadingIcon />
            </SpinnerWrap>
          }
        </SubmitRow>

        { !isStarSubdomain &&
          <Foot>
            <Tagline>{'The Human Skills Company'}</Tagline>
          </Foot>
        }

      </Card>
    </Page>
  )
}
